import { render, staticRenderFns } from "./DeleteBox.vue?vue&type=template&id=0ec15f92&scoped=true"
import script from "./DeleteBox.vue?vue&type=script&lang=js"
export * from "./DeleteBox.vue?vue&type=script&lang=js"
import style0 from "./DeleteBox.vue?vue&type=style&index=0&id=0ec15f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec15f92",
  null
  
)

export default component.exports